import { combineReducers } from '@reduxjs/toolkit';
import restaurantReducer from './restaurantSlice';
import siteContentReducer from './siteContentSlice';
import subscriptionReducer from './subscriptionSlice';
import menuItemsReducer from './menuItemsSlice';
import menuItemDetailsReducer from './menuItemDetailsSlice';
import cartReducer from './cartSlice';
import tpnConfigReducer from './tpnConfigSlice';
import imageUploadReducer from './imageUploadSlice';
import orderReducer from './orderSlice';
import editModeReducer from './editModeSlice';
import editControlReducer from './editControlSlice';
import navEditModeReducer from './navEditModeSlice';
import footerEditModeReducer from './footerEditModeSlice';
import drawerReducer from './globalAIDrawerSlice';
import themeReducer from './themeSlice';
import timeSlotsReducer from './timeSlotsSlice';
import makeReservationReducer from './makeReservationSlice';
import categoriesReducer from './categoriesSlice';
import modifiersReducer from './modifiersSlice';
import modalReducer from './modalSlice';

const rootReducer = combineReducers({
  restaurant: restaurantReducer,
  siteContent: siteContentReducer,
  subscription: subscriptionReducer,
  menuItems: menuItemsReducer,
  menuItemDetails: menuItemDetailsReducer,
  cart: cartReducer,
  tpnConfig: tpnConfigReducer,
  imageUpload: imageUploadReducer,
  order: orderReducer,
  editMode: editModeReducer,
  editControl: editControlReducer,
  navEditMode: navEditModeReducer,
  footerEditMode: footerEditModeReducer,
  drawer: drawerReducer,
  theme: themeReducer,
  timeSlots: timeSlotsReducer,
  makeReservation: makeReservationReducer,
  categories: categoriesReducer,
  modifiers: modifiersReducer,
  modal: modalReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
